import React, {useCallback, useState, useEffect} from 'react'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import withAlert from '../../hoc/withAlerts'
import {useDispatch, useSelector} from 'react-redux'
import { setHeader } from '../../redux/headerSlice'
import Feeds from './dashboard/Feeds'
import Autoreply from './dashboard/Autoreply'
import LoadFeeds from './dashboard/LoadFeeds'
import FinderProgress from './dashboard/FinderProgress'
import TagsAssign from './dashboard/TagsAssign'
import { ROLES, checkPermissions } from '../../roles'
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper'

function Home(props) {    
    const [maxWidth, setMaxWidth] = useState(1200)
    const role = useSelector((state) => state.auth.userdata.role)
    const dispatch = useDispatch()
    
    const showAlertError = useCallback((message) => {
        props.showAlert(message, 'error')
    }, [props])
    
    const resize = () => {
        let w = window.innerWidth
        if (w > 599) {
            w = w - props.navigatorWidth - 60
            if (w < 1200) {
                setMaxWidth(w)
            } else {
                setMaxWidth(1200)
            }
        } else {
            setMaxWidth(w)
        }
    }

    useEffect(() => {
        dispatch(setHeader({
            title: 'Dashboard'
        }))
        window.removeEventListener('resize', resize)
        window.addEventListener('resize', resize)
        resize()
    }, [])
    
    return (
        <Grow in={true}>
            <Stack sx={{maxWidth: maxWidth, margin: 'auto', marginTop: '0px'}}>
                {checkPermissions(role, ROLES.ROLE_USER) ?
                <Grid container spacing={2}>
                    <Grid item lg={6} md={6} xs={12}>
                        <Stack spacing={2}>
                            <Feeds />
                            {checkPermissions(role, ROLES.ROLE_ADMIN) ?
                            <Autoreply />
                            : null }
                        </Stack>
                    </Grid>

                    <Grid item lg={6} md={6} xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <LoadFeeds />
                            </Grid>
                            <Grid item xs={12}>
                                <TagsAssign />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                : null }
            </Stack>
        </Grow>
    )
}

export default withAlert(Home)